import styled from 'styled-components';
import {
  Dropdown as SemanticDropdown,
  Radio as SemanticRadio,
  Table as SemanticTable,
  Popup as SemanticPopup,
} from 'semantic-ui-react';

import { Button as ButtonLayoutComponent, Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

export const Button = styled(ButtonLayoutComponent)``;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  & > * {
    margin: 15px;
  }
`;

export const Container = styled.div`
  display: block;
  width: 100%;
  min-width: 200px;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  > div.details {
    display: flex;
    align-items: center;

    > button {
      color: ${(props) => props.theme.color.primary} !important;
      background: none !important;
      box-shadow: none !important;
      font-weight: normal !important;
    }

    > p {
      cursor: pointer;
    }
  }
`;

export const Dropdown = styled(SemanticDropdown)`
  margin-bottom: 25px;
`;

export const Popup = styled(SemanticPopup)``;

export const Radio = styled(SemanticRadio)`
  padding-right: 10px;
`;

export const Table = styled(SemanticTable)``;

export const Text = styled(TextLayoutComponent)``;
